var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"navBox"},_vm._l((_vm.navList),function(x,i){return _c('div',{key:i,staticClass:"navLi",class:{'navAc':_vm.navAc===x.type},on:{"click":function($event){return _vm.navChange(x.type)}}},[_vm._v(_vm._s(x.text))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }